export default function setStyle () {
  const args = Array.from(arguments) || [{}]
  args.forEach( arg => {
      Object.keys(arg).forEach(key => {
        document.body.style.setProperty(`--${key.replace(/_/g, '-')}`, arg[key])
      })
    })
}
